import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = {
  class: "info",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_7 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_10 = { style: {"color":"red","font-weight":"bolder","margin":"0"} }
const _hoisted_11 = { key: 1 }

import { ref, onMounted } from 'vue'
    import { ElMessage } from 'element-plus'
    import { Tool } from '@/util/tool'
    import axios from 'axios';
    import { useRouter } from 'vue-router';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'Query',
  setup(__props) {


const $router = useRouter();
    const certificate = ref<any>({})
    const isEmpty = ref<boolean>(false)
    const isMobile = ref<boolean>(false)
    const tips = ref<string>('经安全培训，考试合格取得本证书。本证书须每年接受再培训，有效期满需办理再培训换证手续。')
    
    if ( Tool.isMobile() ) {
        isMobile.value = true
    } else {
        isMobile.value = false
    }

    const formatTips = (key: string) => {
      if ( key === 'C_TSJ_201' ) {
        return '本证书须每年接受再培训，考试合格后重新下载证书。'
      } else if ( key === 'C_TSJ_511' ) {
        return '本证书须每3年接受再培训，考试合格后重新下载证书。'
      } else {
        return '本证书须每年接受继续教育，考试合格后重新下载证书。'
      }
    }

    const checkType = (code: string) => {
      if ( code === 'C_TSJ_201' || code === 'C_TSJ_101' || code === 'C_TSJ_502' ) {
        return true
      } else {
        return false
      }
    }

    const setTypeOne  = (code: string ) => {
        if ( code === 'C_TSJ_201' || code === 'C_TSJ_101' || code === 'C_TSJ_502' ) {
            return '行业类别';
        } else if (  code === 'C_TSJ_420' || code === 'C_TSJ_419'  ) {
            return '单位类别';
        } else {
          return '作业类别';
        }
    }

    const setTypeTwo = (code: string) => {
        if ( code === 'C_TSJ_201' || code === 'C_TSJ_101' || code === 'C_TSJ_502' ) {
            return '人员类别';
        } else {
            return '操作项目';
        }
    }

    const checkTType = (code: string) => {
      if ( code === 'C_TSJ_420' || code === 'C_TSJ_419' ) {
        return true
      } else {
        return false
      }
    }

    onMounted(() => {
        init()
    });

    const init = async () => {
        let { id } = $router.currentRoute.value.query
        let res = await axios.get(`/api/certificate/query/${id}`);
        if ( res.data.code === 200 ) {
            let { data } = res.data
            if ( data ) {
                isEmpty.value = true
                certificate.value = data
            }
        } else {
            ElMessage.error(res.data.msg)
        }
    }


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "安全生产和职业健康培训信息查询", -1)),
      _createElementVNode("div", _hoisted_3, [
        (isEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!isMobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (checkTType(certificate.value.subjectCode))
                      ? (_openBlock(), _createBlock(_component_el_descriptions, {
                          key: 0,
                          direction: "horizontal",
                          column: _ctx.line,
                          border: "",
                          width: 140
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                              ]),
                              _: 1
                            }),
                            (certificate.value.idcardNo !== certificate.value.certNo)
                              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                  key: 0,
                                  label: "发证日期"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_descriptions_item, { label: "证件号" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.idcardNo), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, {
                              label: setTypeOne(certificate.value.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_descriptions_item, {
                              label: setTypeTwo(certificate.value.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["column"]))
                      : (checkType(certificate.value.subjectCode))
                        ? (_openBlock(), _createBlock(_component_el_descriptions, {
                            key: 1,
                            direction: "horizontal",
                            column: 2,
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                                ]),
                                _: 1
                              }),
                              (certificate.value.idcardNo !== certificate.value.certNo)
                                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                    key: 0,
                                    label: "初领日期"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_descriptions_item, { label: "证件号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.idcardNo), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: setTypeOne(certificate.value.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_descriptions_item, { label: "最近再培训记录" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.nextTime1), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: setTypeTwo(certificate.value.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_descriptions_item, {
                                label: "说明",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_6, _toDisplayString(formatTips(certificate.value.subjectCode)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (!checkType(certificate.value.subjectCode))
                          ? (_openBlock(), _createBlock(_component_el_descriptions, {
                              key: 2,
                              direction: "horizontal",
                              column: 2,
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                                  ]),
                                  _: 1
                                }),
                                (certificate.value.idcardNo !== certificate.value.certNo)
                                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                      key: 0,
                                      label: "发证日期"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_descriptions_item, {
                                  label: setTypeOne(certificate.value.subjectCode)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, {
                                  label: setTypeTwo(certificate.value.subjectCode)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, {
                                  label: certificate.value.subjectCode !== 'C_TSJ_201' ? '最近再培训记录': '继续教育记录'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.nextTime1), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, {
                                  label: "说明",
                                  span: 4
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(formatTips(certificate.value.subjectCode)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (isMobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (checkTType(certificate.value.subjectCode))
                      ? (_openBlock(), _createBlock(_component_el_descriptions, {
                          key: 0,
                          direction: "horizontal",
                          column: 1,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_descriptions_item, {
                              width: "100",
                              label: "姓名"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, {
                              width: "100",
                              label: "证书编号"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, {
                              width: "100",
                              label: "性别"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                              ]),
                              _: 1
                            }),
                            (certificate.value.idcardNo !== certificate.value.certNo)
                              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                  key: 0,
                                  width: "100",
                                  label: "发证日期"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_descriptions_item, {
                              width: "100",
                              label: "证件号"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.idcardNo), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_descriptions_item, {
                              width: "100",
                              label: setTypeOne(certificate.value.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_descriptions_item, {
                              width: "100",
                              label: setTypeTwo(certificate.value.subjectCode)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : (checkType(certificate.value.subjectCode))
                        ? (_openBlock(), _createBlock(_component_el_descriptions, {
                            key: 1,
                            direction: "horizontal",
                            column: 1,
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_descriptions_item, {
                                width: "100",
                                label: "姓名"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                width: "100",
                                label: "性别"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                width: "100",
                                label: "证件号"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.idcardNo), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                width: "100",
                                label: setTypeOne(certificate.value.subjectCode)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_descriptions_item, {
                                width: "100",
                                label: setTypeTwo(certificate.value.subjectCode),
                                span: 2
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                                ]),
                                _: 1
                              }),
                              (certificate.value.idcardNo !== certificate.value.certNo)
                                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                    key: 0,
                                    width: "100",
                                    label: "初领日期"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(certificate.value.createDate), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_descriptions_item, {
                                width: "100",
                                label: "最近再培训记录"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(certificate.value.nextTime1), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_descriptions_item, {
                                label: "说明",
                                span: 4
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_9, _toDisplayString(formatTips(certificate.value.subjectCode)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (!checkType(certificate.value.subjectCode))
                          ? (_openBlock(), _createBlock(_component_el_descriptions, {
                              key: 2,
                              direction: "horizontal",
                              column: 1,
                              border: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_descriptions_item, {
                                  width: "100",
                                  label: "姓名"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.studenName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "100",
                                  label: "性别"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.gender === '1' ? '男' : '女'), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "100",
                                  label: "证件号"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.idcardNo), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "100",
                                  label: setTypeOne(certificate.value.subjectCode)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.subjectName), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "100",
                                  label: setTypeTwo(certificate.value.subjectCode),
                                  span: 2
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.positionType), 1)
                                  ]),
                                  _: 1
                                }, 8, ["label"]),
                                _createVNode(_component_el_descriptions_item, { label: "证书编号" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.certNo), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, {
                                  width: "100",
                                  label: "最近再培训记录"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(certificate.value.nextTime1), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_descriptions_item, {
                                  label: "说明",
                                  span: 4
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(formatTips(certificate.value.subjectCode)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_el_empty, { description: "未查到相关证书" })
            ]))
      ])
    ])
  ]))
}
}

})